var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"breadcrumbs"},_vm._l((_vm.items),function(item,index){return _c('li',{key:'breadcrumbs-item-' + index,staticClass:"breadcrumbs__item"},[_c('router-link',{class:['breadcrumbs__link', { 'breadcrumbs__link--disabled': !item.route }],attrs:{"to":item.route}},[_vm._v(" "+_vm._s(item.text)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }